import cx from 'classnames'
import React from 'react'

import LoadingSpinner from '@cinch/oxd-components/loading-spinner/src'
import Table from '@cinch/oxd-components/table/src'
import { Text, TextStyles } from '@cinch-labs/design-system'

import { Site } from '@cinch/oxd-pages/wbac/src/types'

import * as styles from './booking-site-address.module.css'

export interface SiteAddressProps {
  site?: Site
  isLoading?: boolean
}

const DAYS: Record<string, string> = {
  0: 'Sunday',
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday',
}

const SiteAddress: React.FC<SiteAddressProps> = ({ site, isLoading }) => {
  if (!site) {
    return null
  }

  const { name, address1, address2, address3, address4, postcode, futureOpenCloseTimesForWeek = [] } = site
  const openingTimes = [...futureOpenCloseTimesForWeek].sort((a, b) => a.dayId - b.dayId)

  if (isLoading) {
    return (
      <div className={cx(styles.address, styles.loading)}>
        <LoadingSpinner />
      </div>
    )
  }

  return (
    <div className={styles.address}>
      <div>
        <Text oxford={true} element={'h4'} type={TextStyles.menuTitle}>
          {name}
        </Text>
        <div className={styles.addressBody}>
          <Text oxford={true} element="address" type={TextStyles.body2}>
            <div>{address1}</div>
            <div>{address2}</div>
            <div>{address3}</div>
            <div>{address4}</div>
            <div>{postcode}</div>
          </Text>
        </div>
      </div>
      {!!openingTimes.length && (
        <div>
          <Text oxford={true} element="h3" type={TextStyles.menuTitle}>
            Opening Times
          </Text>
          <Table isSmall={true}>
            <tbody>
              {openingTimes.map((opening) => (
                <tr key={opening.dayId}>
                  <td>{DAYS[opening.dayId]}</td>
                  <td>
                    {opening.startTime.replace(':00', '')}-{opening.endTime.replace(':00', '')}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  )
}

export default SiteAddress
